import { FormControlLabel, FormControl, Radio, RadioGroup, Typography, Box } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { CampaignInputComponent, CampaignInputComponentProps } from './CampaignInputComponent'
import { ExpenseEvidenceType, FormatVersion } from '~/generated/graphql'
import { z } from 'zod'
import { ValidationErrorMessage } from '~/components/common/ValidationErrorMessage'

export const selectExpenseEvidenceTypeSchemaFields = {
  expenseEvidenceType: z.nativeEnum(ExpenseEvidenceType),
}
export const selectExpenseEvidenceTypeMethodSchema = z.object(selectExpenseEvidenceTypeSchemaFields)

export const SelectExpenseEvidenceType = ({ tooltip }: CampaignInputComponentProps) => {
  const { control } = useFormContext<z.infer<typeof selectExpenseEvidenceTypeMethodSchema>>()

  return (
    <CampaignInputComponent
      title="証憑形式設定"
      tooltip={tooltip}
      required={true}
      compatibleFormatVersions={[FormatVersion.V4Campaign]}
    >
      <Typography variant="body2">どの証憑形式を使用しますか？</Typography>
      <Controller
        control={control}
        name="expenseEvidenceType"
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <Box>
            <FormControl>
              <RadioGroup {...field} ref={ref} defaultValue={ExpenseEvidenceType.Receipt}>
                <FormControlLabel
                  value={ExpenseEvidenceType.Receipt} // 領収証
                  control={<Radio />}
                  label="領収書を証憑とする"
                  sx={{ width: 'fit-content' }}
                />
                <FormControlLabel
                  value={ExpenseEvidenceType.OrderNumber} // 注文番号
                  control={<Radio />}
                  label="注文番号（注文を特定できるID）を証憑とする"
                  sx={{ width: 'fit-content' }}
                />
              </RadioGroup>
            </FormControl>
            {error && <ValidationErrorMessage error={error} />}
          </Box>
        )}
      />
    </CampaignInputComponent>
  )
}
